// @flow

import type { Node } from 'react';
import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { toggleAttachComponent } from 'shared_services/redux/actions/application/pagepreload';

type Props = {
  attach?: boolean,
  uniqueId: string,
  children?: Node,
};

/**
 * DataProviderPreloaderPage
 *
 * @param {Props} props
 * @returns Node
 */
export function DataProviderPreloaderPage({ attach, uniqueId, children }: Props): Node {
  const dispatch: Function = useDispatch();
  const actionToggleAttach = useCallback(
    (id: string, shouldAttach: boolean = true) => {
      dispatch(toggleAttachComponent(id, shouldAttach));
    },
    [dispatch],
  );

  // Call on mount
  useEffect(() => {
    if (attach === true) {
      actionToggleAttach(uniqueId, attach);
    }

    // Call before unmount
    return () => {
      actionToggleAttach(uniqueId, false);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    actionToggleAttach(uniqueId, attach);
  }, [attach]); // eslint-disable-line react-hooks/exhaustive-deps

  return children || null;
}
